export default __webpack_public_path__ + "e54ad3f70ec1e8708d43e150aad08dc3.png";